/**
 * OSIS reference matching shared between Atlas backend and atlas-bake.
 *
 * Refs are strings in OSIS form:
 *   - book           e.g. "Mat"          (whole book)
 *   - book.chapter   e.g. "Mat.21"       (whole chapter)
 *   - book.ch.v      e.g. "Mat.21.10"    (single verse)
 *   - range          e.g. "Gen.12.1-Gen.25.11"
 */
export function parseOsis(raw) {
    const m = raw.trim().match(/^([1-3]?[A-Za-z]+)(?:\.(\d+)(?:\.(\d+))?)?$/);
    if (!m || !m[1])
        return null;
    const parts = { book: m[1] };
    if (m[2] != null)
        parts.chapter = Number(m[2]);
    if (m[3] != null)
        parts.verse = Number(m[3]);
    return parts;
}
export function parseOsisRange(raw) {
    const dash = raw.indexOf('-');
    if (dash === -1) {
        const p = parseOsis(raw);
        return p ? { start: p, end: p } : null;
    }
    const start = parseOsis(raw.slice(0, dash));
    const end = parseOsis(raw.slice(dash + 1));
    if (!start || !end)
        return null;
    return { start, end };
}
function toBounded(p, lo) {
    return [
        p.book.toLowerCase(),
        p.chapter ?? (lo ? 1 : 999),
        p.verse ?? (lo ? 1 : 999),
    ];
}
function cmp(a, b) {
    if (a[0] !== b[0])
        return a[0] < b[0] ? -1 : 1;
    if (a[1] !== b[1])
        return a[1] - b[1];
    return a[2] - b[2];
}
export function refMatches(queryRaw, entryRaw) {
    const q = parseOsisRange(queryRaw);
    const e = parseOsisRange(entryRaw);
    if (!q || !e)
        return false;
    const qLo = toBounded(q.start, true);
    const qHi = toBounded(q.end, false);
    const eLo = toBounded(e.start, true);
    const eHi = toBounded(e.end, false);
    return cmp(qHi, eLo) >= 0 && cmp(qLo, eHi) <= 0;
}
/** Return the OSIS book code (e.g. "Mat") for a ref string, or null if unparseable. */
export function osisBook(raw) {
    const p = parseOsisRange(raw);
    return p ? p.start.book : null;
}
//# sourceMappingURL=osis.js.map